export function isFreeSeatPackage(product) {
  return product?.has_spots === false;
}

function calcCouponSaleAmount(coupon, price) {
  if (!coupon || price < Number(coupon.min_purchase || 0)) {
    return 0;
  }
  if (coupon.discount_type === "price") {
    return Math.min(price, Number(coupon.discount_amount || 0));
  }

  const amount = Math.floor((price * Number(coupon.discount_rate || 0)) / 100);
  const maxDiscount = Number(coupon.max_discount || 0);
  if (amount > maxDiscount) {
    return maxDiscount;
  }
  return amount;
}

export function calculatePackageOrderTotal({
  product,
  spots = [],
  packagePrice = 0,
  optionsPrice = 0,
  coupons = [],
}) {
  const spotCount = spots.length;
  const basePrice = Number(packagePrice || 0);
  let saleAmount = 0;

  if (isFreeSeatPackage(product)) {
    const firstCoupon = coupons[0];
    saleAmount = firstCoupon ? calcCouponSaleAmount(firstCoupon, basePrice) : 0;
  } else {
    saleAmount = spots.reduce((sum, spot) => {
      const coupon = coupons.find((item) => item.spot_id === spot.id);
      return sum + (coupon ? calcCouponSaleAmount(coupon, basePrice) : 0);
    }, 0);
  }

  return basePrice * spotCount + Number(optionsPrice || 0) - saleAmount;
}
